/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "F:/zhaoyanning/mobile-v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import coordtransform from 'coordtransform';
import position from './position';
var WeiXin = {
  wxConfig: function wxConfig(_wxConfig) {
    window.vm.$wechat.config({
      debug: false,
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: _wxConfig.appId,
      // 必填，公众号的唯一标识
      timestamp: _wxConfig.timestamp,
      // 必填，生成签名的时间戳
      nonceStr: _wxConfig.nonceStr,
      // 必填，生成签名的随机串
      signature: _wxConfig.signature,
      // 必填，签名
      jsApiList: ['checkJsApi', 'scanQRCode', 'getLocation', "openLocation", 'chooseImage', 'uploadImage', 'getBrandWCPayRequest' // "openLocation"
      ],
      // 必填，需要使用的JS接口列表
      openTagList: ['wx-open-launch-weapp']
    });
  },
  wxReady: function wxReady(callback) {
    window.vm.$wechat.ready(function () {
      if (callback !== null && typeof callback === 'function') {
        callback();
      }

      window.vm.$wechat.error(function () {});
    });
  },
  wxScanQRCode: function wxScanQRCode(callback) {
    if (callback == null || typeof callback !== 'function') {
      return;
    } // window.vm.$wechat.ready(function () {


    window.vm.$wechat.checkJsApi({
      jsApiList: ['scanQRCode'],
      success: function success() {
        window.vm.$wechat.scanQRCode({
          needResult: 1,
          // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'],
          // 可以指定扫二维码还是一维码，默认二者都有
          success: function success(res) {
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果

            callback({
              codeStr: result,
              code: window.vm.$code.success
            });
          },
          error: function error(res) {
            if (res.errMsg.indexOf('function_not_exist') > 0) {
              callback({
                codeStr: '版本过低请升级',
                code: window.vm.$code.fail
              });
            }
          },
          cancel: function cancel() {
            callback({
              codeStr: '您已经取消扫描',
              code: window.vm.$code.cancel
            });
          }
        });
      }
    }); // });
  },
  wxChooseImage: function wxChooseImage(callback, nums) {
    var sourceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['album', 'camera'];
    window.vm.$wechat.chooseImage({
      count: nums,
      // 默认9
      //'original',
      sizeType: ['compressed'],
      // 可以指定是原图还是压缩图，默认二者都有
      sourceType: sourceType,
      // 可以指定来源是相册还是相机，默认二者都有
      success: function success(res) {
        if (res.errMsg === 'chooseImage:ok') {
          callback(res.localIds);
        }
      },
      fail: function fail(res) {
        console.log(res, 'fail');
      },
      complete: function complete(res) {
        console.log(res, 'complete');
      }
    });
  },
  wxUploadImage: function wxUploadImage(callback, localId) {
    window.vm.$wechat.uploadImage({
      localId: localId,
      // 需要上传的图片的本地ID，由chooseImage接口获得
      isShowProgressTips: 1,
      // 默认为1，显示进度提示
      success: function () {
        var _success = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (res.errMsg === 'uploadImage:ok') {
                    callback(res.serverId);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function success(_x) {
          return _success.apply(this, arguments);
        }

        return success;
      }()
    });
  },
  wxGetLocationCity: function wxGetLocationCity(container, zoom, dragFlag, callback) {
    window.vm.$utils.Store.removeItem('cityAddress');
    var data = {
      flag: false,
      latitude: '',
      longitude: '',
      city: ''
    };
    window.vm.$wechat.ready(function () {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      window.vm.$wechat.checkJsApi({
        jsApiList: ['getLocation'],
        success: function success() {
          window.vm.$wechat.getLocation({
            // 获取地理位置
            type: 'gcj02',
            // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function success(res) {
              // let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              // let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              // let speed = res.speed; // 速度，以米/每秒计
              // let accuracy = res.accuracy; // 位置精度
              var gcj02tobd09 = coordtransform.gcj02tobd09(res.longitude, res.latitude);
              var longitude = gcj02tobd09[0];
              var latitude = gcj02tobd09[1];
              position.getCity(container, longitude, latitude, zoom, dragFlag, function (city) {
                data.flag = true;
                data.latitude = latitude;
                data.longitude = longitude;
                data.city = city;
                window.vm.$utils.Store.setItem('cityAddress', city);

                if (callback !== null && typeof callback === 'function') {
                  callback(data);
                }
              });
            },
            error: function error() {
              if (callback !== null && typeof callback === 'function') {
                callback(data);
              }
            }
          });
          setTimeout(function () {
            if (!window.vm.$utils.Store.getItem('cityAddress')) {
              window.vm.$utils.Tools.loadHide();
              window.vm.$utils.Tools.toastShow('获取定位失败，请检查手机GPS是否开启');
            }
          }, 10000);
        },
        error: function error() {
          if (callback !== null && typeof callback === 'function') {
            callback(data);
          }
        }
      });
      window.vm.$wechat.error(function () {
        if (callback !== null && typeof callback === 'function') {
          callback(data);
        }
      });
    });
  },
  //重新调用微信定位
  wxGetLocation: function wxGetLocation(container, zoom, dragFlag, callback) {
    if (callback == null || typeof callback !== 'function') {
      return;
    }

    var data = {
      flag: false,
      latitude: '',
      longitude: '',
      address: '',
      address2: ''
    };
    window.vm.$wechat.ready(function () {
      /*  config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
        所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。 */
      window.vm.$wechat.checkJsApi({
        jsApiList: ['getLocation'],
        success: function success() {
          window.vm.$wechat.getLocation({
            // 获取地理位置
            type: 'gcj02',
            // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function success(res) {
              // let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              // let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              // let speed = res.speed; // 速度，以米/每秒计
              // let accuracy = res.accuracy; // 位置精度
              var gcj02tobd09 = coordtransform.gcj02tobd09(res.longitude, res.latitude);
              var longitude = gcj02tobd09[0];
              var latitude = gcj02tobd09[1];
              position.getMarkerBd(container, longitude, latitude, zoom, dragFlag, function (rtn) {
                data.flag = true;
                data.latitude = rtn.latitude;
                data.longitude = rtn.longitude;
                data.address = rtn.address;
                data.address2 = rtn.address2;

                if (callback !== null && typeof callback === 'function') {
                  callback(data);
                }
              });
            },
            error: function error() {
              if (callback !== null && typeof callback === 'function') {
                callback(data);
              }
            }
          });
        },
        error: function error() {
          if (callback !== null && typeof callback === 'function') {
            callback(data);
          }
        }
      });
    });
  },
  wxGetBusLocation: function wxGetBusLocation(container, zoom, dragFlag, callback) {
    if (callback == null || typeof callback !== 'function') {
      return;
    }

    var data = {
      flag: false,
      latitude: '',
      longitude: '',
      address: '',
      address2: ''
    }; // window.vm.$wechat.ready(() => {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

    window.vm.$wechat.checkJsApi({
      jsApiList: ['getLocation'],
      success: function success() {
        window.vm.$wechat.getLocation({
          // 获取地理位置
          type: 'gcj02',
          // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function success(res) {
            // let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            // let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            // let speed = res.speed; // 速度，以米/每秒计
            // let accuracy = res.accuracy; // 位置精度
            var gcj02tobd09 = coordtransform.gcj02tobd09(res.longitude, res.latitude);
            var longitude = gcj02tobd09[0];
            var latitude = gcj02tobd09[1];
            position.getMarkerBd(container, longitude, latitude, zoom, dragFlag, function (rtn) {
              data.flag = true;
              data.latitude = rtn.latitude;
              data.longitude = rtn.longitude;
              data.address = rtn.address;
              data.address2 = rtn.address2;

              if (callback !== null && typeof callback === 'function') {
                callback(data);
              }
            });
          },
          error: function error() {
            if (callback !== null && typeof callback === 'function') {
              callback(data);
            }
          }
        });
      },
      error: function error() {
        if (callback !== null && typeof callback === 'function') {
          callback(data);
        }
      }
    });
  },
  wxOpenLocation: function wxOpenLocation(Location, callback) {
    if (callback == null || typeof callback !== 'function') {
      return;
    } // window.vm.$wechat.ready(() => {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。


    window.vm.$wechat.checkJsApi({
      jsApiList: ['openLocation'],
      success: function success() {
        window.vm.$wechat.openLocation({
          // 获取地理位置
          latitude: Location.lat,
          // 纬度，浮点数，范围为90 ~ -90
          longitude: Location.log,
          // 经度，浮点数，范围为180 ~ -180。
          name: Location.name,
          // 位置名
          address: Location.address,
          // 地址详情说明
          scale: 1,
          // 地图缩放级别,整型值,范围从1~28。默认为最大
          infoUrl: '',
          // 在查看位置界面底部显示的超链接,可点击跳转
          success: function success(res) {
            if (callback !== null && typeof callback === 'function') {
              callback(res);
            }
          },
          error: function error() {
            if (callback !== null && typeof callback === 'function') {
              callback();
            }
          }
        });
      },
      error: function error() {
        if (callback !== null && typeof callback === 'function') {
          callback();
        }
      }
    });
  },
  // 退出公众号窗口
  closeWindow: function closeWindow() {
    window.vm.$wechat.closeWindow();
  }
};
export default WeiXin;